module.exports = __webpack_public_path__ + "img/signup-guide-04-04.1cee29f6.png";